import * as React from 'react';
import { useSelector } from 'react-redux';
import * as _ from 'lodash';

import { eventElementDataSelector } from '@/redux/app/selectors/event';
import { Note } from './Note';

export interface CallNoteProps {
  ticket: string;
  id: string;
}

export const CallNote = ({ ticket, id }: CallNoteProps) => {
  const data = useSelector(_.partial(eventElementDataSelector, ticket, id));
  return (
    <Note
      id={id}
      body={data.body}
      senderType={data.sender_type}
      senderId={data.sender_id}
      senderTag={data.sender_tag}
      sentAt={data.sent_at}
    />
  );
};
